<template>
    <split-pane  :min-percent='12' :default-percent='15' split="vertical" style="background:white; height:100%">
        <template slot="paneL">
              <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"></el-input>
                <el-tree :data="orgData" 
                            :props="defaultProps" 
                            @node-click="handleNodeClick" 
                            default-expand-all
                            node-key="id"                       
                            :style="{height: scrollerHeight,overflow:'auto', 'margin-top':'3px'}"
                            highlight-current
                            ref="eltree"
                            v-loading="loading"
                            :filter-node-method="filterNode"
                            element-loading-text="加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(255, 251, 255, 0.8)"
                            :expand-on-click-node="false">
                    <template v-slot="{node,data}">                                     
                        <span v-if="data.id ==0 "  class="nodeRoot" > 
                          <span  style="font-size:14px;color:#409efe"><i class="iconfont  icon-wuliaoguanli" style="color:#409eff;font-size:18px;margin-right:4px;"></i>{{ node.label}} </span>
                        </span>                  
                        <span v-else > 
                            <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#F56C6C;font-size:12px;margin-right:4px;"></i> {{ node.label}} </span>
                        </span>
                    </template>
                </el-tree>    
        </template>
        <template slot="paneR">
            <div style="background:#fff;  "> 
                <div style="width:100%; border-bottom:2px solid #389;padding-top:3px;display:flex;line-height:30px;height:38px">
                    <div style=" width:240px" >
                      <i class="iconfont icon-xitongguanli" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                      <el-link :disabled="addBool" @click="typeSet" :underline="false" ><span style="font-size:12px;margin-right:15px;">物料类别设置</span></el-link>  
                      <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                      <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">新增类别属性</span></el-link>
                    </div>
                    <div style=" width:560px" >
                      <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px; ">
                          <span v-for="item in tabCol" :key='item.key'>
                              <el-option :label="item.title" :value="item.key"></el-option>
                          </span>
                      </el-select>
                      <el-input placeholder="请输入查询值" ref="refqry" v-model="textparam" size="small" style="width:320px; height:30px; ">
                          <el-select v-model="oper" slot="prepend" size="small" style="width:110px; ">
                                <span v-for="item in operArr" :key='item.IDSEQ'>
                                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                                    </span>
                            </el-select>
                          <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                      </el-input>   
                    </div>
                </div>
                    <el-table :data="tmpData" 
                        border                            
                        disabled-hover
                        class="custom-table-border"
                        :row-key="getRowKey"
                        @row-click="dtlClick"
                        style="overflow:auto;margin-top:3px;"
                        size="small"
                        ref="proptab"
                        height="300px" 
                        highlight-current-row>
                        <span  v-for="(item ,index) in tabCol" :key="index">   
                            <el-table-column   v-if="item.thide==='N' &&item.key!=='ISHAND'"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"                                  
                                sortable
                                :min-width="item.width">
                            </el-table-column> 
                            <el-table-column  v-if=" item.key==='ISHAND'"
                                prop="STFG"
                                label="手动输入"
                                align="center"                                  
                                sortable
                                width="100">
                                <template slot-scope="scope" >
                                    <el-checkbox disabled false-label="" true-label="Y" v-model="scope.row.ISHAND" >&nbsp;</el-checkbox>
                                </template>
                            </el-table-column> 
                        </span> 
                        <el-table-column
                            fixed="right"
                            label="操作"
                            align="center"
                            width="130">
                            <template slot-scope="scope"> 
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link :disabled="editBool" @click="editRec(scope.row )" :underline="false"  ><span style="font-size:11px;margin-right:10px;">编辑 </span></el-link>
                                <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link :disabled="delBool" @click="delRec(scope.row )" :underline="false"  ><span style="font-size:11px; ">删除 </span></el-link>
                            </template>
                        </el-table-column>                       
                    </el-table>
                    <div style="border-bottom:1px solid #ccc;border-left:2px solid #e6aef0;height:35px;margin-top:2px;line-height:35px;">
                       <i class="iconfont icon-xinzeng" style="color:#1090FF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                       <el-link :disabled="addBool" @click="dtlAdd" :underline="false" ><span style="font-size:12px;margin-right:15px;">新增属性规格</span></el-link>
                    </div>
                    <el-table :data="dtlData" 
                        border                            
                        disabled-hover
                        :row-key="getRowKey2"
                        style="overflow:auto;margin-top:3px;"
                        size="small"
                        class="custom-table-border"
                        ref="dtltab"
                        :height="tabHeight" 
                        highlight-current-row>
                        <span  v-for="(item ,index) in dtlCol" :key="index">   
                            <el-table-column   v-if="item.thide==='N'"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"                                  
                                sortable
                                :min-width="item.width">
                            </el-table-column> 
                        </span> 
                        <el-table-column
                            fixed="right"
                            label="操作"
                            align="center"
                            width="130">
                            <template slot-scope="scope"> 
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link :disabled="editBool" @click="dtlEdit(scope.row )" :underline="false"  ><span style="font-size:11px;margin-right:10px;">编辑 </span></el-link>
                                <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:10px;"></i>
                                <el-link :disabled="delBool" @click="dtlDel(scope.row )" :underline="false"  ><span style="font-size:11px; ">删除 </span></el-link>
                            </template>
                        </el-table-column>                       
                    </el-table>
                    <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addModal" width="1050px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
                        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                            <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">属性：{{type==='create'?'新增':type==='edit'?'编辑':'查看'}}</span>
                        </div> 
                        <Form :model="propRow" :label-width="120" ref="addForm" label-position="right" inline  :rules="ruleValidate">  
                            <span v-for="(item,index) in tabCol" :key="index" >
                                <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                                    <el-date-picker  type="date"  v-if="item.edcss==='date'" v-model="propRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                    <el-input   v-enter-number  v-else-if="item.edcss==='number'" v-model="propRow[item.key]" style="width:100%" ></el-input>   
                                    <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="propRow[item.key]" style="width:100%"></el-checkbox> 
                                    <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="propRow[item.key]"></el-input>
                                </FormItem>
                            </span>
                        </Form>
                        <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                            <span style="float:right">
                                <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addModal=false" style="margin-right:25px;">取消</el-button>
                                <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="modal_ok" style="margin-right:10px;">保存</el-button>
                            </span>
                        </div>  
                    </el-dialog> 
                    <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="dtlModal" width="1050px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
                        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                            <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">规格：{{dtlFlag==='create'?'新增':type==='edit'?'编辑':'查看'}}</span>
                        </div> 
                        <Form :model="dtlRow" :label-width="120" ref="addForm" label-position="right" inline  :rules="ruleValidate">  
                            <span v-for="(item,index) in dtlCol" :key="index" >
                                <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                                    <el-date-picker  type="date"  v-if="item.edcss==='date'" v-model="dtlRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                    <el-input   v-enter-number  v-else-if="item.edcss==='number'" v-model="dtlRow[item.key]" style="width:100%" ></el-input>   
                                    <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="dtlRow[item.key]" style="width:100%"></el-checkbox> 
                                    <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="dtlRow[item.key]"></el-input>
                                </FormItem>
                            </span>
                        </Form>
                        <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                            <span style="float:right">
                                <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="dtlModal=false" style="margin-right:25px;">取消</el-button>
                                <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="dtl_ok" style="margin-right:10px;">保存</el-button>
                            </span>
                        </div>  
                    </el-dialog> 
                </div>
                <el-dialog v-dialogDrag :visible.sync="dialogVisible" width="450px" append-to-body :show-close="false">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                    </div> 
                    <span>{{prompt}}</span>
                    <span slot="footer"  >
                        <el-button size="small" type="primary" @click="dialogVisible = false">确 定</el-button>
                    </span>
                </el-dialog>
                <el-dialog v-dialogDrag :visible.sync="typeWin" width="800px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">产品类别设置</span>
                    </div>
                    <prodType @child-close="freshTree"></prodType>
                </el-dialog>
        </template>
    </split-pane>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
import prodType from '../datamgt/mattype.vue' 
export default {
    name: 'mat_attrib',
    data () {
        return {
            addModal:false, //modal 
            typeWin:false,
            oper:'like',
            readFlag:false, //查看标志
            prompt:'', // 
            dtlModal:false,
            dtlName:'',
            dtlRow:{},
            dialogVisible:false,
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'',// select 绑定值
            textparam:'', // input 绑定值
            tabCol:[] ,//表列集合
            tmpData:[] ,// 
            filterText: '',
            lvl:'1',
            operArr:[],
            dtlFlag:'create',
            baseData:[] ,//表数据
            propRow:{} ,//  
            orgData:[] ,//组织部门 
            dtlData:[],
            dtlCol:[],
            disabled:false,
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'',
                label: 'label'
            },
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            type:'create',
            ruleValidate: {},
            dtlIdseq:'',
            dtlLstseq:'',
            formCol:{}, //表格单行记录 model
             
            notNull:[],
            treeid:'0',
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止 
            v_admin:this.$cookies.get('v_admin') ,//  
        }
    },
    created () {
        this.getTabCol() //得到 表列数组 
        
        this.getData() //表单 分组 数据  
    },
    components: {
        prodType,
    },
    mounted () {   
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })  
        this.$refs.refqry.focus()
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4271','lstseq','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
         //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_formurl+'','userno',this.v_username ,'frmidseq','4271','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                console.log(JSON.stringify(row))
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
        this.getFormData( '-1','') //初始查询表数据   
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -470
        },
        scrollerHeight: function() {
            return (window.innerHeight - 130) + 'px';
        }, 
    },
    watch: {
      filterText(val) {
        this.$refs.eltree.filter(val);
      }
    },
    methods: {  
        typeSet(){
            this.typeWin =true
        },
        //类别维护
        freshTree(){
            this.getData()
        },
        dtlAdd(){
          if (!this.dtlIdseq){
            this.dialogVisible=true
            this.prompt='属性名称为空时不能新增'
          }else{
            this.dtlModal=true
            this.dtlRow={PCNAME:this.dtlName}
            this.dtlFlag='create'
          }
        },
        getRowKey(row){
          return row.LSTSEQ
        },
        getRowKey2(row){
          return row.ITMSEQ
        },
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.lvl=data.icon
            if (data.id==='0'){
                this.getFormData( '-1','')
            }else{
                this.getFormData( data.id,'')
            }
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            this.loading =true
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_MAT_TYPE',p_cond:' and corpid=\''+this.v_corpid+'\' and ty=\'MAT\'' }
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.orgData =res.result
                    vm.loading =false 
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                } else{
                    vm.dialogVisible=true
                    vm.prompt=res.result
                }  
                         
            })                            
        },
        //规格保存 
        dtl_ok(){  
            if(this.dtlRow['CNAME']){ 
                  this.$axios({
                      method: 'post',
                      url:'xuper_auth/tableBodySave2',
                      data: {p_json:JSON.stringify(Object.assign(this.dtlRow,{CORPID:this.v_corpid,IDSEQ:this.dtlIdseq,LSTSEQ:this.dtlLstseq})), p_table:'prd_propdtl'},
                  }).then(res=>{      
                      if(res.code ==='200')  {          
                          this.dtlModal =false   
                          this.getDtlData(this.dtlIdseq,this.dtlLstseq)
                      }else{
                          if (res.result.indexOf('ORA-00001')>-1){
                            this.dialogVisible=true
                            this.prompt='重复的属性规格值，请核查'
                          }else{
                            this.dialogVisible=true
                            this.prompt=res.result
                          }
                      }        
                  }) 
            }else{
                this.dialogVisible=true
                this.prompt='属性规格值不能为空'
            }
        }, 
        //表单确定按钮 两个特殊数据类型： null ,undefined 当为null时 用 ! ,为undefined 用 typeof
        modal_ok(){
            //var verify = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
            let ctryno_=''
            //发起保存请求   
            this.$refs['addForm'].validate((valid) => {  
                if (valid)  {     
                    console.log('id:'+this.treeid)
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/tableBodySave',
                        data: {p_json:JSON.stringify(Object.assign(this.propRow,{CORPID:this.v_corpid })), p_table:'prd_prop',p_idseq:this.treeid},
                    }).then(res=>{      
                        if(res.code ==='200')  {          
                            this.addModal =false   
                            this.qryTabData()
                        }else{
                            if (res.result.indexOf('ORA-00001')>-1){
                                this.dialogVisible=true
                                this.prompt='重复的属性名称，请核查'
                            }else{
                                this.dialogVisible=true
                                this.prompt=res.result
                            }
                        }        
                    }) 
                }
            })
        },
        //删除记录
        delRec(row,index){
          this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
               this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_table:'prd_prop'},
                }).then(res=>{      
                    if(res.code =='200')  {      
                        this.tmpData.splice(index,1 )      
                    }else{
                        this.dialogVisible=true
                        this.prompt=res.result
                    }        
                }) 
            }).catch(()=>{})
        },
        dtlDel(row,index){
          this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
               this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_key3:'itmseq',p_value3:row.ITMSEQ,p_table:'prd_propdtl'},
                }).then(res=>{      
                    if(res.code =='200')  {      
                        this.dtlData.splice(index,1 )      
                    }else{
                        this.dialogVisible=true
                        this.prompt=res.result
                    }        
                }) 
            }).catch(()=>{})
        },
        //新增记录
        addRec(){
          if (this.lvl=='1'||this.lvl=='0'){
            this.dialogVisible=true
            this.prompt='该节点下不能新增,请选择子节点新增'
          }else{
            this.addModal =true
            this.type ='create'
            this.propRow ={PCODE:this.treeid,PCNAME:this.nodeLabel,ISHAND:'N'}
          }
        },
        //修改记录
        editRec(row,val){
           this.propRow=JSON.parse(JSON.stringify(row)) 
           this.addModal =true         
           this.type='edit'
        },
        dtlEdit(row ){
           this.dtlRow=JSON.parse(JSON.stringify(row)) 
           this.dtlModal =true         
           this.dtlFlag='edit'
        },
        //查询选择器事件
        elchange(value){
            let obj ={}
            obj =this.tabCol.find(item=>{
                return item.key===value
            })
            this.input_hold='请输入'+obj.title+' 的值'
        },
        //查询表格数据
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.textparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.textparam+'\''
                }
            }
            this.getFormData( this.treeid,cond_ )
        },
 
        //获取表单数据
        getFormData( subno,cond){
            getTabColOrData(this.v_formurl,'v_PRD_PROP','IDSEQ',subno,'','',cond).then((res) => {              
                if (res.code==='200'){
                    this.tmpData=res.result
                    if(res.result.length>0){
                      this.dtlIdseq=res.result[0].IDSEQ
                      this.dtlLstseq=res.result[0].LSTSEQ
                      this.dtlName=res.result[0].CNAME
                      this.$refs.proptab.setCurrentRow(this.tmpData[0])
                      //明细查询第一行属性
                      this.getDtlData(res.result[0].IDSEQ,res.result[0].LSTSEQ)
                    }else{
                      this.dtlData=[]
                      this.dtlIdseq=''
                      this.dtlLstseq=''
                    }   
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.proptab.doLayout();
                    }) 
                }else{
                    this.dialogVisible=true
                    this.prompt=res.result
                }    
            });            
        },
        //明细数据
        getDtlData( idseq,lstseq){
            getTabColOrData(this.v_formurl,'v_PRD_PROPDTL','IDSEQ',idseq,'lstseq',lstseq,'').then((res) => {              
                if (res.code==='200'){
                    this.dtlData=res.result    
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.dtltab.doLayout();
                    })
                }else{
                    this.dialogVisible=true
                    this.prompt=res.result
                }    
            });            
        },
        dtlClick(row){
          this.getDtlData(row.IDSEQ,row.LSTSEQ)
          this.dtlIdseq=row.IDSEQ
          this.dtlLstseq=row.LSTSEQ
          this.dtlName=row.CNAME
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4271','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            });
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4271','LSTSEQ','2' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
        },
    }
}
 
</script>
<style scoped lang="less" >
    
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
